import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { ImageWithFallback } from './figma/ImageWithFallback';
import { motion } from 'framer-motion';
import productBg from "../assets/asian-girl.png"

interface ProductPageProps {
  t: any;
  language: string;
}

export default function ProductPage({ t }: ProductPageProps) {

  const faqItems = [
    { id: 'item-1', question: t.faq.q1.question, answer: t.faq.q1.answer },
    { id: 'item-2', question: t.faq.q2.question, answer: t.faq.q2.answer },
    { id: 'item-3', question: t.faq.q3.question, answer: t.faq.q3.answer },
    { id: 'item-4', question: t.faq.q4.question, answer: t.faq.q4.answer },
    { id: 'item-5', question: t.faq.q5.question, answer: t.faq.q5.answer },
    { id: 'item-6', question: t.faq.q6.question, answer: t.faq.q6.answer },
    { id: 'item-7', question: t.faq.q7.question, answer: t.faq.q7.answer },
    { id: 'item-8', question: t.faq.q8.question, answer: t.faq.q8.answer },
    { id: 'item-9', question: t.faq.q9.question, answer: t.faq.q9.answer },
    { id: 'item-10', question: t.faq.q10.question, answer: t.faq.q10.answer },
    { id: 'item-11', question: t.faq.q11.question, answer: t.faq.q11.answer },
    { id: 'item-12', question: t.faq.q12.question, answer: t.faq.q12.answer },
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-b from-[#1A1A1A] to-gray-900 relative h-screen flex items-center justify-center overflow-hidden">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="absolute inset-0 z-0">
            <ImageWithFallback
              src={productBg}
              alt="Happy child playing with gamepad"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black opacity-70"></div>
          </div>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className=" text-4xl md:text-6xl font-bold mb-8 text-emerald-600 relative z-10 whitespace-pre-line leading-4 md:leading-7"
          >
            {t.heroTitle}
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-lg text-gray-300 leading-relaxed relative z-10"
          >
            {t.heroDescription}
          </motion.p>
        </div>
      </section>

      <section className="py-20 bg-[#1A1A1A]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-3xl md:text-4xl font-bold text-center mb-12 text-emerald-600"
          >
            {t.whatDoes}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-lg text-start text-gray-300 relative z-10 "
            dangerouslySetInnerHTML={{ __html: t.content }}
            />
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-3xl md:text-4xl font-bold text-center mb-16 text-emerald-600"
          >
            {t.faq.title}
          </motion.h2>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <Accordion type="single" collapsible className="space-y-4">
              {faqItems.map((item) => (
                <AccordionItem
                  key={item.id}
                  value={item.id}
                  className="bg-gray-800 border-gray-700 rounded-lg px-6"
                >
                  <AccordionTrigger className="text-left text-white hover:text-emerald-600 hover:no-underline">
                    <span className="text-lg font-medium">{item.question}</span>
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-300 text-base leading-relaxed pb-6">
                    {/* {item.answer} */}
                    <div dangerouslySetInnerHTML={{ __html: item.answer }} />
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
